import styled from 'styled-components';

export const $CircleProgressBar = styled.svg`
  transform: rotate(-90deg);
`;

export const $TextValue = styled.text<{ $size: number }>`
  transform: ${({ $size }) => `rotate(90deg) translate(0px, -${$size - 4}px)`};
`;
